// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-margin--HOzob{margin-bottom:60px}.modal-buttons--s8bU7{display:flex;justify-content:space-between}", "",{"version":3,"sources":["webpack://./src/pages/Products/components/BillingTypeModal/billing-modal.module.scss"],"names":[],"mappings":"AAEA,wBACE,kBAAA,CAGF,sBACE,YAAA,CACA,6BAAA","sourcesContent":["@use '@/assets/styles/global/variables' as variables;\n\n.dropdown-margin {\n  margin-bottom: 60px;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown-margin": "dropdown-margin--HOzob",
	"modal-buttons": "modal-buttons--s8bU7"
};
export default ___CSS_LOADER_EXPORT___;
